import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '../../contexts/AuthContext';
import toast from 'react-hot-toast';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import api from '../../services/api';

const { FiUser, FiLock, FiShield, FiCreditCard, FiUsers, FiMail, FiPhone, FiMapPin, FiCheck, FiEdit3, FiPlus, FiTrash2, FiX, FiGlobe, FiNavigation, FiSave, FiInfo } = FiIcons;

const UserSettings = () => {
    const { user, updateUser } = useAuth();
    const [activeTab, setActiveTab] = useState('profile');
    const [isEditing, setIsEditing] = useState(false);
    const [isEditingTeamName, setIsEditingTeamName] = useState(false);
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        full_name: user?.full_name || '',
        email: user?.email || '',
        phone: user?.phone || '',
        address: user?.address || '',
        city: user?.city || '',
        zip_code: user?.zip_code || '',
        country: user?.country || ''
    });

    const [teamNameInput, setTeamNameInput] = useState(user?.teamName || '');

    const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });

    const [teamMembers, setTeamMembers] = useState([]);
    const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
    const [isEditMemberModalOpen, setIsEditMemberModalOpen] = useState(false);
    const [inviteData, setInviteData] = useState({ name: '', email: '' });
    const [editingMember, setEditingMember] = useState(null);

    const isSuperAdmin = user?.role === 'Super Admin';
    const isTeamLead = user?.role === 'Team Lead' || user?.subscription_tier === 'Team';
    const canManageTeam = isSuperAdmin || isTeamLead;
    const hasTeamName = !!user?.teamName;
    const memberLimit = user?.memberLimit || 10;

    useEffect(() => {
        if (activeTab === 'team' && canManageTeam) {
            loadTeamMembers();
        }
    }, [activeTab, canManageTeam]);

    const loadTeamMembers = async () => {
        // try {
        //     const members = await api.getTeamMembers(user.id);
        //     setTeamMembers(members || []);
        // } catch (error) {
        //     toast.error('Failed to load team members');
        // }
    };

    const tabs = [
        { id: 'profile', label: 'Profile', icon: FiUser },
        { id: 'security', label: 'Security', icon: FiShield },
        { id: 'subscription', label: 'Subscription', icon: FiCreditCard },
        ...(canManageTeam ? [{ id: 'team', label: 'Team', icon: FiUsers }] : [])
    ];

    const handleSaveProfile = async () => {
        setLoading(true);
        try {
            // await api.updateProfile(user.id, formData);
            await api.put('/auth/me', formData);
            toast.success('Profile updated successfully!');
            setIsEditing(false);
            updateUser(formData);
        } catch (error) {
            toast.error('Failed to update profile');
            console.log(error);
            
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateTeamName = async () => {
        // if (!teamNameInput.trim()) return toast.error('Team name cannot be empty');
        // if (teamNameInput.length > 15) return toast.error('Team name max 15 characters');

        // setLoading(true);
        // try {
        //     const tName = teamNameInput.trim();
        //     await api.updateTeamName(user.id, tName);
        //     toast.success('Team name updated successfully!');
        //     setIsEditingTeamName(false);
        //     updateUser({ teamName: tName });
        // } catch (error) {
        //     toast.error(error.message || 'Failed to update team name');
        // } finally {
        //     setLoading(false);
        // }
    };

    const handleChangePassword = async (e) => {
        e.preventDefault();
        if (passwordData.new_password !== passwordData.confirm_password) {
            return toast.error('New passwords do not match');
        }
        setLoading(true);
        try {
            // await api.changePassword(user.id, passwordData);
            await api.put('/auth/change-password', passwordData)
            toast.success('Password changed successfully!');
            setPasswordData({ current_password: '', new_password: '', confirm_password: '' });
        } catch (error) {
            toast.error('Failed to change password');
            console.log(error);
            
        } finally {
            setLoading(false);
        }
    };

    const handleUpgrade = async (tier) => {
        // let tName = null;
        // if (tier === 'Team') {
        //     tName = prompt('Enter a unique Team Name (max 15 characters):');
        //     if (!tName) return;
        //     if (tName.length > 15) return toast.error('Team name too long');
        // }

        // try {
        //     await api.upgradeSubscription(user.id, tier, tName);
        //     toast.success(`Upgraded to ${tier} plan!`);
        //     updateUser({ subscription_tier: tier, teamName: tName });
        // } catch (error) {
        //     toast.error(error.message || 'Failed to upgrade');
        // }
    };

    // const handleCancelSubscription = async () => {
    //     if (window.confirm('Are you sure?')) {
    //         try {
    //             await api.cancelSubscription(user.id);
    //             toast.success('Subscription cancelled');
    //             updateUser({ subscription_tier: 'Free' });
    //         } catch (error) {
    //             toast.error('Failed to cancel');
    //         }
    //     }
    // };

    const handleInviteMember = async (e) => {
        e.preventDefault();
        if (teamMembers.length >= memberLimit) {
            return toast.error(`Member limit of ${memberLimit} reached.`);
        }
        // try {
        //     await api.inviteTeamMember({
        //         leadId: user.id,
        //         name: inviteData.full_name,
        //         email: inviteData.email,
        //         teamName: user.teamName
        //     });
        //     toast.success('Invitation sent!');
        //     setIsInviteModalOpen(false);
        //     setInviteData({ name: '', email: '' });
        //     loadTeamMembers();
        // } catch (error) {
        //     toast.error(error.message || 'Failed to invite member');
        // }
    };

    const handleEditMember = (member) => {
        setEditingMember({ ...member });
        setIsEditMemberModalOpen(true);
    };

    const handleUpdateMember = async (e) => {
        // e.preventDefault();
        // setLoading(true);
        // try {
        //     await api.updateTeamMember(editingMember.id, {
        //         full_name: editingMember.full_name,
        //         email: editingMember.email,
        //         status: editingMember.status,
        //         leadId: user.id
        //     });
        //     toast.success('Team member updated');
        //     setIsEditMemberModalOpen(false);
        //     loadTeamMembers();
        // } catch (error) {
        //     toast.error('Failed to update member');
        // } finally {
        //     setLoading(false);
        // }
    };

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="mb-8">
                    <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Account Settings</h1>
                    <p className="text-gray-600 dark:text-gray-300">Manage your account preferences and security</p>
                </motion.div>

                <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
                    <div className="lg:col-span-1">
                        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6">
                            <div className="flex items-center mb-6">
                                <img src={user?.avatar} alt={user?.full_name} className="w-16 h-16 rounded-full mr-4" />
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{user?.full_name}</h3>
                                    <p className="text-sm text-gray-500 dark:text-gray-400">{user?.subscription_tier} Plan</p>
                                </div>
                            </div>
                            <nav className="space-y-2">
                                {tabs.map((tab) => (
                                    <button
                                        key={tab.id}
                                        onClick={() => setActiveTab(tab.id)}
                                        className={`w-full flex items-center px-4 py-3 text-left rounded-lg transition-colors ${activeTab === tab.id
                                                ? 'bg-primary-50 dark:bg-primary-900/20 text-primary-600 dark:text-primary-400'
                                                : 'text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700/50'
                                            }`}
                                    >
                                        <SafeIcon icon={tab.icon} className="w-5 h-5 mr-3" />
                                        {tab.label}
                                    </button>
                                ))}
                            </nav>
                        </div>
                    </div>

                    <div className="lg:col-span-3">
                        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700">
                            {activeTab === 'profile' && (
                                <div className="p-6">
                                    <div className="flex items-center justify-between mb-6">
                                        <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Profile Information</h2>
                                        <button
                                            onClick={() => setIsEditing(!isEditing)}
                                            className="flex items-center px-4 py-2 text-primary-600 dark:text-primary-400 hover:bg-primary-50 dark:hover:bg-primary-900/20 rounded-lg transition-colors"
                                        >
                                            <SafeIcon icon={isEditing ? FiX : FiEdit3} className="w-4 h-4 mr-2" />
                                            {isEditing ? 'Cancel' : 'Edit'}
                                        </button>
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-gray-900 dark:text-white">
                                        <div className="space-y-2">
                                            <label className="text-sm font-medium">Full Name</label>
                                            <input type="text" disabled={!isEditing} value={formData.full_name} onChange={(e) => setFormData({ ...formData, full_name: e.target.value })} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700" />
                                        </div>
                                        <div className="space-y-2">
                                            <label className="text-sm font-medium">Email Address</label>
                                            <input type="email" disabled value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700" />
                                        </div>
                                        <div className="space-y-2">
                                            <label className="text-sm font-medium">Phone</label>
                                            <input type="text" disabled={!isEditing} value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700" />
                                        </div>
                                        <div className="space-y-2">
                                            <label className="text-sm font-medium">Address</label>
                                            <input type="text" disabled={!isEditing} value={formData.address} onChange={(e) => setFormData({ ...formData, address: e.target.value })} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700" />
                                        </div>
                                        <div className="space-y-2">
                                            <label className="text-sm font-medium">City</label>
                                            <input type="text" disabled={!isEditing} value={formData.city} onChange={(e) => setFormData({ ...formData, city: e.target.value })} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700" />
                                        </div>
                                        <div className="space-y-2">
                                            <label className="text-sm font-medium">Zip Code</label>
                                            <input type="text" disabled={!isEditing} value={formData.zip_code} onChange={(e) => setFormData({ ...formData, zip_code: e.target.value })} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700" />
                                        </div>
                                        <div className="space-y-2">
                                            <label className="text-sm font-medium">Country</label>
                                            <input type="text" disabled={!isEditing} value={formData.country} onChange={(e) => setFormData({ ...formData, country: e.target.value })} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700" />
                                        </div>
                                    </div>
                                    {isEditing && (
                                        <div className="mt-6 flex justify-end">
                                            <button onClick={handleSaveProfile} disabled={loading} className="px-6 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors">
                                                {loading ? 'Saving...' : 'Save Changes'}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}

                            {activeTab === 'security' && (
                                <div className="p-6">
                                    <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-6">Security</h2>
                                    <form onSubmit={handleChangePassword} className="space-y-4 max-w-md text-gray-900 dark:text-white">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Current Password</label>
                                            <input type="password" required value={passwordData.currentPassword} onChange={(e) => setPasswordData({ ...passwordData, currentPassword: e.target.value })} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white" />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">New Password</label>
                                            <input type="password" required value={passwordData.newPassword} onChange={(e) => setPasswordData({ ...passwordData, newPassword: e.target.value })} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white" />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Confirm New Password</label>
                                            <input type="password" required value={passwordData.confirmPassword} onChange={(e) => setPasswordData({ ...passwordData, confirmPassword: e.target.value })} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white" />
                                        </div>
                                        <button type="submit" disabled={loading} className="px-6 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors">Update Password</button>
                                    </form>
                                </div>
                            )}

                            {activeTab === 'subscription' && (
                                <div className="p-6">
                                    <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-6">Subscription</h2>
                                    <div className="p-6 bg-primary-50 dark:bg-primary-900/20 rounded-xl mb-8">
                                        <p className="text-xs font-semibold text-primary-600 dark:text-primary-400 uppercase tracking-wider mb-1">Current Plan</p>
                                        <h3 className="text-xl font-semibold text-gray-900 dark:text-white">{user?.subscription_tier}</h3>
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                        {['Free', 'Pro', 'Team'].map((tier) => (
                                            <div key={tier} className={`p-6 rounded-xl border ${user?.subscription_tier === tier ? 'border-primary-500 bg-primary-50/30' : 'border-gray-200 dark:border-gray-700'}`}>
                                                <h4 className="text-lg font-semibold text-gray-900 dark:text-white">{tier}</h4>
                                                <p className="text-sm text-gray-500 mb-4">{tier === 'Free' ? '$0' : tier === 'Pro' ? '$2.99/mo' : '$19.99/mo'}</p>
                                                {user?.subscription_tier === tier ? (
                                                    <span className="text-primary-600 font-medium">Active Plan</span>
                                                ) : (
                                                    <button onClick={() => handleUpgrade(tier)} className="w-full py-2 bg-white dark:bg-gray-800 border border-primary-600 text-primary-600 rounded-lg hover:bg-primary-600 hover:text-white transition-all">
                                                        {tier === 'Free' ? 'Downgrade' : 'Upgrade'}
                                                    </button>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {activeTab === 'team' && canManageTeam && (
                                <div className="p-6 space-y-10">
                                    {/* Team Name Section */}
                                    <div>
                                        <div className="flex items-center gap-2 mb-6">
                                            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Team Settings</h2>
                                        </div>

                                        <div className="p-6 bg-gray-50 dark:bg-gray-700/30 rounded-xl border border-gray-200 dark:border-gray-700">
                                            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                                                <div className="flex-1 w-full">
                                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                                        Team Name
                                                    </label>
                                                    <div className="flex items-center gap-2">
                                                        {isEditingTeamName ? (
                                                            <div className="flex-1 relative">
                                                                <input
                                                                    type="text"
                                                                    maxLength={15}
                                                                    value={teamNameInput}
                                                                    onChange={(e) => setTeamNameInput(e.target.value)}
                                                                    className="w-full px-4 py-2 border border-primary-500 dark:border-primary-400 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white outline-none transition-all"
                                                                    placeholder="Enter team name..."
                                                                    autoFocus
                                                                />
                                                                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[10px] font-medium text-gray-400">
                                                                    {teamNameInput.length}/15
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <div className={`flex-1 py-2 px-4 border rounded-lg text-gray-900 dark:text-white ${user?.teamName ? 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700' : 'bg-yellow-50 dark:bg-yellow-900/20 border-yellow-200 dark:border-yellow-900/40 text-yellow-700 dark:text-yellow-400 italic'}`}>
                                                                {user?.teamName || 'Team Name Not Set'}
                                                            </div>
                                                        )}

                                                        <div className="flex items-center gap-2">
                                                            {isEditingTeamName ? (
                                                                <>
                                                                    <button onClick={handleUpdateTeamName} disabled={loading} className="p-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-all shadow-sm" title="Save"><SafeIcon icon={FiSave} className="w-5 h-5" /></button>
                                                                    <button onClick={() => { setIsEditingTeamName(false); setTeamNameInput(user?.teamName || ''); }} className="p-2 bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-200 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-500 transition-all shadow-sm" title="Cancel"><SafeIcon icon={FiX} className="w-5 h-5" /></button>
                                                                </>
                                                            ) : (
                                                                <button onClick={() => setIsEditingTeamName(true)} className="p-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-all shadow-sm" title="Edit Team Name"><SafeIcon icon={FiEdit3} className="w-5 h-5" /></button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mt-3 flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
                                                <SafeIcon icon={FiInfo} className="w-3.5 h-3.5 text-primary-500" />
                                                <span>Maximum 15 characters. A unique team name is required before adding members.</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Team Members Section */}
                                    <div className={`relative transition-all duration-300 ${!hasTeamName ? 'opacity-40 grayscale pointer-events-none' : ''}`}>
                                        {!hasTeamName && (
                                            <div className="absolute inset-0 z-10 flex items-center justify-center">
                                                <div className="bg-white/95 dark:bg-gray-800/95 px-6 py-3 rounded-lg border border-yellow-200 dark:border-yellow-900/40 shadow-lg flex items-center gap-3">
                                                    <SafeIcon icon={FiLock} className="w-4 h-4 text-yellow-500" />
                                                    <p className="text-sm font-medium text-gray-800 dark:text-gray-200">Set a team name to unlock member management</p>
                                                </div>
                                            </div>
                                        )}

                                        <div className="flex items-center justify-between mb-6">
                                            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Manage Team Members</h2>
                                            <button
                                                onClick={() => setIsInviteModalOpen(true)}
                                                disabled={teamMembers.length >= memberLimit}
                                                className={`flex items-center px-4 py-2 rounded-lg text-sm font-medium transition-all ${teamMembers.length >= memberLimit ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-primary-600 hover:bg-primary-700 text-white'}`}
                                            >
                                                <SafeIcon icon={FiPlus} className="w-4 h-4 mr-2" />
                                                Invite Member
                                            </button>
                                        </div>

                                        <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
                                            <div className="p-4 bg-gray-50 dark:bg-gray-800/50 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between">
                                                <div className="flex items-center gap-2">
                                                    <span className="text-sm text-gray-500 dark:text-gray-400">Team Size:</span>
                                                    <span className={`text-sm font-semibold ${teamMembers.length >= memberLimit ? 'text-red-500' : 'text-primary-600'}`}>
                                                        {teamMembers.length} / {memberLimit}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="overflow-x-auto">
                                                <table className="w-full">
                                                    <thead>
                                                        <tr className="text-left bg-gray-50/50 dark:bg-gray-800/50 border-b border-gray-100 dark:border-gray-700">
                                                            <th className="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Name</th>
                                                            <th className="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Email</th>
                                                            <th className="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Status</th>
                                                            <th className="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider text-right">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="divide-y divide-gray-50 dark:divide-gray-800">
                                                        {teamMembers.map((member) => (
                                                            <tr key={member.id} className="hover:bg-gray-50/50 dark:hover:bg-gray-700/20 transition-colors">
                                                                <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-white">{member.full_name}</td>
                                                                <td className="px-6 py-4 text-sm text-gray-500 dark:text-gray-400">{member.email}</td>
                                                                <td className="px-6 py-4">
                                                                    <span className={`px-2.5 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wide ${member.status === 'Active' ? 'bg-green-100 text-green-700' : member.status === 'Inactive' ? 'bg-red-100 text-red-700' : 'bg-yellow-100 text-yellow-700'}`}>
                                                                        {member.status}
                                                                    </span>
                                                                </td>
                                                                <td className="px-6 py-4 text-right">
                                                                    <button onClick={() => handleEditMember(member)} className="text-primary-600 hover:text-primary-700 text-xs font-semibold inline-flex items-center"><SafeIcon icon={FiEdit3} className="w-3.5 h-3.5 mr-1" />Edit</button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {teamMembers.length === 0 && (
                                                            <tr>
                                                                <td colSpan="4" className="px-6 py-10 text-center text-gray-400 text-sm italic">
                                                                    No team members found. Start by inviting someone!
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Invite Modal */}
            <AnimatePresence>
                {isInviteModalOpen && (
                    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
                        <motion.div initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.95, opacity: 0 }} className="bg-white dark:bg-gray-800 rounded-xl p-8 w-full max-w-md shadow-xl border border-gray-200 dark:border-gray-700">
                            <div className="flex items-center justify-between mb-6">
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white">Invite Member</h3>
                                    <p className="text-xs text-gray-500 mt-1">Add a new professional to your team</p>
                                </div>
                                <button onClick={() => setIsInviteModalOpen(false)} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"><SafeIcon icon={FiX} className="w-5 h-5" /></button>
                            </div>
                            <form onSubmit={handleInviteMember} className="space-y-5">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">Full Name</label>
                                    <input type="text" required value={inviteData.full_name} onChange={(e) => setInviteData({ ...inviteData, name: e.target.value })} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-primary-500/20" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">Email Address</label>
                                    <input type="email" required value={inviteData.email} onChange={(e) => setInviteData({ ...inviteData, email: e.target.value })} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-primary-500/20" />
                                </div>
                                <button type="submit" disabled={loading} className="w-full py-2.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700 font-semibold text-sm transition-all">
                                    {loading ? 'Processing...' : 'Send Invitation'}
                                </button>
                            </form>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>

            {/* Edit Member Modal */}
            <AnimatePresence>
                {isEditMemberModalOpen && editingMember && (
                    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
                        <motion.div initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.95, opacity: 0 }} className="bg-white dark:bg-gray-800 rounded-xl p-8 w-full max-w-md shadow-xl border border-gray-200 dark:border-gray-700">
                            <div className="flex items-center justify-between mb-6">
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white">Edit Professional</h3>
                                    <p className="text-xs text-gray-500 mt-1">Update team member profile and status</p>
                                </div>
                                <button onClick={() => setIsEditMemberModalOpen(false)} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"><SafeIcon icon={FiX} className="w-5 h-5" /></button>
                            </div>
                            <form onSubmit={handleUpdateMember} className="space-y-5">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">Full Name</label>
                                    <input type="text" required value={editingMember.full_name} onChange={(e) => setEditingMember({ ...editingMember, full_name: e.target.value })} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-primary-500/20" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">Email Address</label>
                                    <input type="email" required value={editingMember.email} onChange={(e) => setEditingMember({ ...editingMember, email: e.target.value })} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-primary-500/20" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">Status</label>
                                    <select value={editingMember.status} onChange={(e) => setEditingMember({ ...editingMember, status: e.target.value })} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-primary-500/20 font-medium">
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                        <option value="Pending">Pending</option>
                                    </select>
                                </div>
                                <button type="submit" disabled={loading} className="w-full py-2.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700 font-semibold text-sm transition-all">
                                    {loading ? 'Saving Updates...' : 'Confirm Changes'}
                                </button>
                            </form>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default UserSettings;